import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-upcoming-appoinment',
  templateUrl: './upcoming-appoinment.component.html',
  styleUrls: ['./upcoming-appoinment.component.scss']
})
export class UpcomingAppoinmentComponent implements OnInit {
  teamDropdown: any;
  myClasses = 'inactive';
  btnClass = 'btn-grey';
  constructor() {}

  ngOnInit() {
    this.teamDropdown = [{ name: 'Iron Ways' }, { name: 'Keyhole' }];
  }
  addClasses(ev) {
    if (this.myClasses == ev) {
      this.myClasses = 'inactive';
      this.btnClass = 'btn-grey';
    } else {
      this.myClasses = 'active';
      this.btnClass = '';
    }
  }
}
